import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./definition-list-description.css?inline";

@customElement("eko-definition-list-description")
class DefinitionListDescription extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ type: Boolean }) truncate = false;

  render() {
    return html`<dd class="eko-definition-list__description"><slot></slot></dd>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-definition-list-description": DefinitionListDescription;
  }
}

export default DefinitionListDescription;
